import { FormErrorsList } from '../../common/FormErrorsList'

export interface FormError {
  sectionIndex: number
  [key: string]: any
}

interface FormErrorListProps {
  errors?: FormError[]
  sectionIndex: number
  navigateToError: () => void
  typeProps?: { showAllErrors?: boolean, showSectionErrors?: boolean }
  title?: string
}

/**
 * Form element which renders a list of errors, either for the entire form or only one of its sections (depending on the selected prop).
 * @category Form
 * @subcategory Form elements
 * @component
 * @returns {JSX.Element}
 * @param  {Object} typeProps - Element specific properties that can be configured in form editor.
 * @param  {boolean}  [typeProps.showAllErrors=false] Render the current list of error for the the whole form.
 * @param  {boolean}  [typeProps.showSectionErrors=false] Render the current list of error for a given section.
 * @param {string} [props.title] Error message to be displayed.
 */
export const FormErrorList = ({
  errors,
  sectionIndex,
  navigateToError,
  typeProps,
  title
}: FormErrorListProps): JSX.Element => {
  const { showAllErrors, showSectionErrors = false } = typeProps ?? {}
  let errorsToPass: FormError[] = errors ?? []
  if (showSectionErrors) {
    errorsToPass = errorsToPass.filter((obj) => sectionIndex === obj.sectionIndex)
  }

  return (
    <FormErrorsList
      title={title}
      navigateToError={navigateToError}
      errors={errorsToPass}
    />
  )
}
